import { ChangeEvent, useState } from "react";
import styled from "styled-components";

import SearchInput from "./SearchInput";
import VehicleTypes from "./VehicleTypes";
import { layout } from "styled-system";

const StyledContainer = styled.form`
  display: flex;
  flex: 1;
  ${layout}
`;

export default function SearchBar({
  options,
  savedSearches,
  recentSearches,
  isAuthenticated,
  auctionViewRoot,
  searchRootURL,
  defaultSearchTerm = "",
}: {
  options: { shortName: string; withCount: string }[];
  savedSearches: { label: string; url: string }[];
  recentSearches: { label: string; url: string }[];
  isAuthenticated: boolean;
  auctionViewRoot: string;
  searchRootURL: string;
  defaultSearchTerm?: string;
}) {
  const [searchTerm, setSearchTerm] = useState(defaultSearchTerm);
  const [vehicleType, setVehicleType] = useState("All");

  // const serializedVehicleType = vehicleType === "All" ? "*" : vehicleType;

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const rootUrl =
    searchRootURL.charAt(searchRootURL.length - 1) === "/"
      ? searchRootURL.slice(0, -1)
      : searchRootURL;

  return (
    <StyledContainer action={`${rootUrl}/search?q=${searchTerm}`} method="GET">
      <input type="hidden" name="q" value={searchTerm} />
      {/** TBD if this should  be removed
      <input type="hidden" name="vehicleType" value={serializedVehicleType} /> */}
      <VehicleTypes
        options={options}
        onVehicleTypeChange={(type) => {
          setVehicleType(type);
        }}
        selectedType={vehicleType}
      ></VehicleTypes>
      <SearchInput
        ml="1px"
        value={searchTerm}
        onChange={handleInputChange}
        savedSearches={savedSearches}
        recentSearches={recentSearches}
        isAuthenticated={isAuthenticated}
        auctionViewRoot={auctionViewRoot}
        vehicleType={vehicleType}
      ></SearchInput>
    </StyledContainer>
  );
}
